interface IPeopleSearchHistory {
  search: string;
  timestamp: string;
}

export default function usePeopleSearchHistory() {
  const saveSearch = (search: string) => {
    const searchHistory = localStorage.getItem('searchHistory');
    if (searchHistory) {
      const searchHistoryArray = JSON.parse(searchHistory);
      const currentDate = new Date();
      const existingSearchWithinDay = searchHistoryArray.find(
        (item: IPeopleSearchHistory) =>
          item.search === search &&
          new Date(item.timestamp).getDate() === currentDate.getDate() &&
          new Date(item.timestamp).getMonth() === currentDate.getMonth() &&
          new Date(item.timestamp).getFullYear() === currentDate.getFullYear()
      );
      if (!existingSearchWithinDay) {
        searchHistoryArray.push({ search, timestamp: new Date().toISOString() });
      } else {
        searchHistoryArray.splice(searchHistoryArray.indexOf(existingSearchWithinDay), 1);
        searchHistoryArray.push({ search, timestamp: new Date().toISOString() });
      }
      localStorage.setItem('searchHistory', JSON.stringify(searchHistoryArray));
    } else {
      localStorage.setItem(
        'searchHistory',
        JSON.stringify([{ search, timestamp: new Date().toISOString() }])
      );
    }
  };

  const getSearches = (): IPeopleSearchHistory[] => {
    const searchHistory = localStorage.getItem('searchHistory');
    if (searchHistory) {
      return JSON.parse(searchHistory).sort(
        (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
      );
    }

    return [];
  };

  const clearSearches = () => {
    localStorage.removeItem('searchHistory');
  };

  return { saveSearch, getSearches, clearSearches };
}
